module.exports = __webpack_public_path__ + "008eabc78179726b714f6b813df798c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/gamecenter/vn/roulette.jpg
// module id = 650
// module chunks = 30